import { useState } from 'react';
import httpClient from 'API/httpClient';
import { ApiError } from 'types/apiError';

export interface ContactFormData {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  message: string;
  captchaToken: string;
  website: string;
}

const useSendContactUsEmail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState<boolean | null>(null);
  const [error, setError] = useState<ApiError | null>(null);

  const formatFormDataToHTML = (
    formData: Omit<ContactFormData, 'captchaToken' | 'website'>,
  ): string => {
    const { firstName, lastName, email, company, message } = formData;

    return `
      <p><strong>First Name:</strong> ${firstName}</p>
      <p><strong>Last Name:</strong> ${lastName}</p>
      <p><strong>Email:</strong> ${email}</p>
      <p><strong>Company:</strong> ${company}</p>
      <p><strong>Message:</strong> ${message}</p>
    `;
  };

  const sendEmail = async (formData: ContactFormData) => {
    setIsLoading(true);
    setIsSuccess(null);
    setError(null);

    const { captchaToken, website, ...emailFormData } = formData;
    const formHTML = formatFormDataToHTML(emailFormData);

    try {
      await httpClient.post('/send-email', {
        ...emailFormData,
        captchaToken,
        website,
        html: formHTML,
        subject: emailFormData.company
          ? `Contact form / Akyga battery x ${emailFormData.company}`
          : 'Contact form / Akyga battery',
        email: emailFormData.email,
        supportEmail: 'sales@akygabattery.com',
      });
      setIsSuccess(true);
    } catch (err) {
      setIsSuccess(false);
      setError(err as ApiError);
      console.error('There was an error sending the email:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return { sendEmail, isLoading, isSuccess, error };
};

export default useSendContactUsEmail;
